module.exports = __webpack_public_path__ + "static/media/penreg.d1541253.svg";